import { useState } from "react";
import LayoutActividad from "../../../components/LayoutActividad";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { modulo13 } from "../../../routes/Module13";
import GuiaDocente from "../../../components/GuiaDocente";
import Sidebar from "../Sidebar";
import { faComments } from "@fortawesome/free-solid-svg-icons";

import Imagen1 from "../../../images/modulo13/huaico.png";
import Card from "../../../components/Card";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo13/Unidad3Actividad5.mp3";

const Actividad9 = () => {
  const [answers, setAnswers] = useState({
    ans1: { value: "", valid: "", correctValue: "1" },
    ans2: { value: "", valid: "", correctValue: "1" },
    ans3: { value: "", valid: "", correctValue: "1" },
    ans4: { value: "", valid: "", correctValue: "0" },
  });
  const infoUnidad = modulo13.content[2];
  const infoAct = modulo13.content[2].activities[6];
  const crumbs = [
    {
      title: modulo13.title,
      url: "/" + modulo13.url,
    },
    {
      title:
        modulo13.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];

  const pages = {
    titleNext: `${modulo13.content[2].name}: ${modulo13.content[2].activities[7].name}`,
    linkNext: `${modulo13.url}/${modulo13.content[2].path}/${modulo13.content[2].activities[7].path}`,
    titlePrev: `${modulo13.content[2].name}: ${modulo13.content[2].activities[5].name}`,
    linkPrev: `${modulo13.url}/${modulo13.content[2].path}/${modulo13.content[2].activities[5].path}`,
  };
  const metadata = {
    color: modulo13.color,
    title: `${modulo13.title} - ${infoAct.name}`,
    name: modulo13.title,
  };

  const handleAnswers = (event, name) => {
    if (answers[name]["value"] === event.target.value) {
      setAnswers({
        ...answers,
        [name]: { ...answers[name], value: "2" },
      });
    } else {
      setAnswers({
        ...answers,
        [name]: { ...answers[name], value: event.target.value },
      });
    }
  };

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo13.color} hat-text`}>
          <FontAwesomeIcon icon={faComments} /> Dialogamos
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
          <AudioPlayer track={Audio} />

      <div className="row">
        <div className="col-lg-10 col-12 p-0">
          <ul>
            <li>Lee el siguiente texto y observa la imagen.</li>
          </ul>

          <Card>
            <p className="fs-5 p-3 p-md-0">
              En marzo de 2015, al menos 12 viviendas quedaron destruidas tras
              las intensas lluvias en Chaviñas, Ayacucho. Los vecinos pidieron
              ayuda a las autoridades. El aumento del caudal del río también
              destruyó el único puente para vehículos de la zona.
            </p>
            <p>
              <small>
                (Adaptado de:{" "}
                <a href="http://www.americatv.com.pe/noticias/actualidad/ayacucho-huaico-destruyo-12-viviendaschavinas-n173414">
                  http://www.americatv.com.pe/noticias/actualidad/ayacucho-huaico-destruyo-12-viviendaschavinas-n173414
                </a>
                )
              </small>
            </p>
            <img src={Imagen1} alt="ministerio" className="img-fluid" />
          </Card>

          <ul>
            <li>
              Ahora lee las siguientes afirmaciones y marca aquellas que sean
              hechos y deja en blanco las que sean una opinión.
            </li>
          </ul>

          <div className="d-flex align-items-center mb-1">
            <input
              className={"form-check-input me-1 form-md " + answers.ans1.valid}
              type="checkbox"
              value="1"
              checked={answers.ans1.value === "1"}
              onChange={(event) => handleAnswers(event, "ans1")}
            />
            <div>
              A la gente que construye sus casas en las quebradas no le importa
              que sea peligroso.
            </div>
          </div>
          <div className="d-flex align-items-center mb-1">
            <input
              className={"form-check-input me-1 form-md " + answers.ans2.valid}
              type="checkbox"
              value="1"
              checked={answers.ans2.value === "1"}
              onChange={(event) => handleAnswers(event, "ans2")}
            />
            <div>
              Sería bueno que las autoridades informen a los vecinos sobre los
              peligros de construir en ciertas zonas.
            </div>
          </div>
          <div className="d-flex align-items-center mb-1">
            <input
              className={"form-check-input me-1 form-md " + answers.ans3.valid}
              type="checkbox"
              value="1"
              checked={answers.ans3.value === "1"}
              onChange={(event) => handleAnswers(event, "ans3")}
            />
            <div>Los huaicos solo ocurren en época de lluvias.</div>
          </div>
          <div className="d-flex align-items-center">
            <input
              className={"form-check-input me-1 form-md " + answers.ans4.valid}
              type="checkbox"
              value="1"
              checked={answers.ans4.value === "1"}
              onChange={(event) => handleAnswers(event, "ans4")}
            />
            <div>
              Cuando hay un huaico, se ven afectados los vecinos que pierden sus
              propiedades y también las autoridades.
            </div>
          </div>

          <ul className="mt-5">
            <li>
            Conversa con un compañero, compañera o familiar y responde estas preguntas:
            </li>
          </ul>
          <p>
            ¿Dónde podrían buscar información para comprobar si los hechos
            mencionados son ciertos?
          </p>
          <textarea className="form-control mb-4" rows={3} />
          <p>
            ¿Qué piensan acerca de las opiniones presentadas? ¿Están de acuerdo
            con ellas? ¿Por qué?
          </p>
          <textarea className="form-control" rows={3} />
        </div>
      </div>

      <GuiaDocente>
        <ul>
          <li>
            Explique que en las siguientes actividades
            reflexionarán sobre la construcción de las ciudades y su relación
            con el entorno. Para ello, intercambiarán opiniones con sus
            compañeros y compañeras. Recuérdeles la importancia de escuchar
            opiniones distintas y de dar opiniones bien argumentadas.
          </li>
          <li>
            Lea la primera indicación: Lee el siguiente texto y observa la
            imagen. Pida a un estudiante que lea el texto en voz alta y
            asegúrese de que todos lo hayan comprendido. Lea la segunda
            indicación: Ahora lee las siguientes afirmaciones y marca aquellas
            que sean hechos y deja en blanco las que sean una opinión. Recuerda
            que un hecho es algo que se puede comprobar y una opinión es un
            juicio o una valoración. Asegúrese de que entienden
            la diferencia entre una opinión y un hecho. Para ello, puede
            ayudarlos con algunos ejemplos:
            <ul>
              <li>
                <i>
                  “Es un hecho que te encuentras en la escuela en este momento.
                  Es una opinión que la clase de hoy día te gustó.
                </i>
              </li>
              <li>
                <i>
                  Es un hecho que hoy es un día soleado. Es una opinión que los
                  días soleados son mis favoritos”.
                </i>
              </li>
            </ul>
          </li>
          <li>
            Dé un tiempo para que clasifiquen las ideas
            propuestas y luego pida que lean las afirmaciones y sus respuestas.
            Para cada afirmación, pida que expliquen por qué se trata de un
            hecho o una opinión. Por ejemplo: (O) A la gente que construye sus
            casas en las quebradas no le importa que sea peligroso. “¿Por qué se
            trata de una opinión? (Posible respuesta: Porque es la percepción de
            una persona sobre lo que piensa la gente de construir sus casas en
            las quebradas)”. Continúe con las siguientes oraciones.
          </li>
          <li>
            Lea la indicación y las preguntas: Compara tus respuestas con un
            compañero o compañera y conversen sobre esto: - ¿Dónde podrían
            buscar información para comprobar si los hechos mencionados son
            ciertos? - ¿Qué piensan acerca de las opiniones presentadas? ¿Están
            de acuerdo con ellas? ¿Por qué?
          </li>
          <li>
            Monitoree mientras realizan el trabajo. Pida sus respuestas. Verifique que
            sean coherentes.
          </li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad9;
